module.exports = __webpack_public_path__ + "img/stock2.7e1886cc.png";